import { ContentSection, Heading, Text } from '@cinch-labs/design-system'
import { StoryblokImage, StoryBlokRichText } from '@cinch-nx/data-storyblok'
import Image from 'next/image'
import React from 'react'

import renderWithResolver from '../../../rich-text-renderer/rich-text-renderer'
import styles from './feature-image-card.module.css'

export interface FeatureImageCardProps {
  image: StoryblokImage
  iconTitle: string
  heading: string
  body: StoryBlokRichText
}

export const FeatureImageCard: React.FC<FeatureImageCardProps> = ({
  image,
  iconTitle,
  heading,
  body,
}) => (
  <div className={styles.container}>
    <div className={styles.cardMedia}>
      <div className={styles.imageWrapper}>
        <Image
          fill
          src={image.filename}
          alt={image.alt ?? ''}
          style={{ objectFit: 'cover' }}
        />
      </div>
      <Text className={styles.iconTitleText}>{iconTitle}</Text>
    </div>
    <Heading className={styles.cardHeading}>{heading}</Heading>
    <ContentSection
      sectionWrapperClass={styles.sectionWrapper}
      classNames={{ body: styles.cardBody }}
    >
      {renderWithResolver(body)}
    </ContentSection>
  </div>
)
